import { Banner } from '@/components/ui/banner'
import { SUPPORT_EMAIL } from '@/config/config'

export function EndorsementWarning() {
  return (
    <Banner variant="warning">
      Endorsements like &apos;Additional Insured&apos; or &apos;Waiver of Subrogation&apos; require manual
      review. Please contact us at <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>.
    </Banner>
  )
}
